;(function($, undefined){

    var rnn = window.rnn,
        maps,
        loading,
        ieSelector = 'internetExploder',
        hasFileReader = !!window.FileReader,
        createControlGroup = rnn.modules.forms.createControlGroup;

    //https://gist.github.com/1126989
    Array.isArray||(Array.isArray=function(a){return{}.toString.call(a)=='[object Array]';});


    function createImageUploadField(isStory){
        return createControlGroup({
            name:'image',
            element:'input',
            type:'file',
            title: 'Add Image',
            label: isStory &&  'Add an image to your story by clicking the button below',
            append:$.el.button({'type':'button', 'class':'addImage btn'},
                $.el.i({'class':'icon20x20-camera'}),
                ' Add Image'
            )
        });
    }

    /////////////////////
    // Create Story or Image Form
    /////////////////////

    function createUGCForm(settings){
        //Extend when there are more types
        return createShareForm(settings);
    }

    function createShareForm(settings){
        var subType = settings.subtype.toLowerCase(),
            isStory = subType === 'story',
            isImage = subType === 'image',
            ugcForm = $($.el.form({'class': 'ugc ' + subType, 'method': 'POST', 'action': settings.url, 'enctype':'multipart/form-data', 'encoding':'multipart/form-data'},

                $($.el.p({'class':'intro'})).html(settings.intro)[0],

                $.el.input({'name':'media_request', 'type':'hidden', 'class':'mediaRequest', 'value': settings.id}),
                settings.contentObject && $.el.input({'name':'content_object_type', 'type':'hidden', 'class':'mediaRequest', 'value': settings.contentObject.contentType}),
                settings.contentObject && $.el.input({'name':'content_object_id', 'type':'hidden', 'class':'mediaRequest', 'value': settings.contentObject.objectId}),

                !isImage && createControlGroup({name:'title', placeholder:'Title', title: 'Title', hideLabel: true}),

                isStory && createControlGroup({name:'details', placeholder:'Tell us what happened...', element:'textarea', title: 'Details', hideLabel: true}),


                $.el.div({'class':'imageAttachments'},

                    $.el.div({'class':'thumbContainer'},
                        !hasFileReader && $.el.p('Selected Image:'),
                        !hasFileReader && $.el.div({'class':'thumb'}) || $.el.img({'class':'thumb'})
                    ),

                    $.el.div({'class':'imageUpload'},

                        createImageUploadField(isStory),

                        createControlGroup({name:'caption', placeholder:'Image caption', title: 'Image Caption'})
                    )
                ),


                $.el.div({'class': 'footer'},

                    // rnn.modules.tags.create({url: rnn.site.tagsURL, name:'tags', placeholder:'Add a tag', title: 'Tags', multiSelect: true, element: 'select'}),

                    createControlGroup({
                        name:'terms_and_conditions',
                        type:'checkbox',
                        label:[
                            'I certify that I have the right to distribute these photos and I agree with the ',
                            $.el.a({'href':'/submissions/terms-and-conditions/', 'target':'_blank'}, 'Terms and Conditions')
                        ],
                        placeholder:'Caption your image',
                        title: 'Terms and conditions'
                    }),

                    $.el.button({'type':'submit', 'class':'btn btn-primary'}, "Submit your " + subType)
                )
            ));

        if(!hasFileReader){
            var frameId = new Date().getTime().toString(),
                submitFrame = $($.el.iframe({'id':frameId, 'name': frameId, src:"about:blank"}));

            submitFrame.hide();

            ugcForm.attr('target', frameId);

            submitFrame.on('load',function(event){
                var response,
                    $this = $(this);

                if(!$this.data('isloaded')){

                    $(this).data('isloaded', true);

                    return;
                }

                try{
                    response = $.parseJSON(this.contentWindow.document.body.innerText);

                    if(response.result === 'success'){
                        typeof submitSuccess === "function" && submitSuccess(ugcForm, response);
                    }else{
                        typeof submitError === "function" && submitError(ugcForm, response);
                    }
                }catch (e){
                    typeof submitError === "function" && submitError(ugcForm, response);
                }
            });


            ugcForm.append(submitFrame);

        }

        return ugcForm;
    }


    /////////////////////
    // Set Loading State
    /////////////////////

    function setLoadingState(ugcForm){
        ugcForm.stop(true, true).slideUp().after(loading.createBar());
    }

    function clearLoadingState(ugcForm){
        loading.removeBar(ugcForm.stop(true, true).slideDown().parent());
    }




    /////////////////////
    // Submit form in a browser
    /////////////////////

    // http://stackoverflow.com/questions/166221/how-can-i-upload-files-asynchronously-with-jquery
    // with fixes
    function submitUgcFormProper(ugcForm, settings, success, error, complete){
        var formData = new FormData(ugcForm[0]);


        $.ajax({
            url: settings.url,
            type: 'post',
            xhr: function() {  // custom xhr
                myXhr = $.ajaxSettings.xhr();
                if(myXhr.upload && typeof progressHandlingFunction === 'function'){
                    myXhr.upload.addEventListener('progress',progressHandlingFunction, false);
                }
                return myXhr;
            },
            success: function(data){
                data = $.parseJSON(data);
                if(data.errors){
                    typeof error === 'function' && error(ugcForm, data);
                }else{
                    typeof success === 'function' && success(ugcForm, data);
                }
            },
            error: function(data){
                typeof error === 'function' && error(ugcForm, data);
            },
            complete: function(data){
                typeof complete === 'function' && error(ugcForm, data);
            },
            data: formData,
            cache: false,
            contentType: false,
            processData: false
        });
    }

    /////////////////////
    // Clear Fields
    /////////////////////

    function resetForm(ugcForm){
        var settings = ugcForm.parent().data().ugc,
            isHidden = !ugcForm.stop(true, true).is(':visible'),
            newForm = createUGCForm(settings);

        ugcForm.after(newForm).remove();

        isHidden && newForm.hide();

        return newForm;
    }


    /////////////////////
    // Clear Errors
    /////////////////////

    function clearErrors(ugcForm){
        ugcForm.find('.error').removeClass('error');
    }


    /////////////////////
    // Clear Alert
    /////////////////////

    function clearAlert(ugcForm){
        var oldAlert = ugcForm.data('alert');

        ugcForm.data('alert', null);

        oldAlert && oldAlert.remove();
    }


    /////////////////////
    // Show Alert
    /////////////////////

    function showAlert(ugcForm, options){
        clearAlert(ugcForm);

        ugcForm.data('alert',
            rnn.modules.alert.show(ugcForm, options)
        );
    }


    function createSuccessMessage(subtype){
        return 'Your ' + subtype + ' was submitted successfully and is currently under review.';
    }


    /////////////////////
    // Submit Success
    /////////////////////

    function submitSuccess(ugcForm, data){

        ugcForm = resetForm(ugcForm);

        showAlert(ugcForm,{
            prepend: true,
            type:'success',
            heading:'Success',
            message: createSuccessMessage(ugcForm.parent().data('ugc').subtype)
        });

        clearLoadingState(ugcForm);
    }

    /////////////////////
    // Submit Error
    /////////////////////

    function submitError(ugcForm, data){
        var errorFields = data.errors,
            errorAlert;

        clearLoadingState(ugcForm);
        clearAlert(ugcForm);
        clearErrors(ugcForm);

        if(!errorFields){
            return;
        }

        errorAlert = rnn.modules.forms.createErrorsAlert(ugcForm, errorFields);

        ugcForm.data('alert', errorAlert);
        ugcForm.prepend(errorAlert);

    }

    /////////////////////
    // Submit Handler
    /////////////////////

    function submitUgcForm(event){
        var ugcForm = $(this),
            settings = ugcForm.parent().data('ugc');

        setLoadingState(ugcForm);

        if(hasFileReader){
            event.preventDefault();

            submitUgcFormProper(ugcForm, settings, submitSuccess, submitError);
        }
    }


    //http://stackoverflow.com/questions/1095102/how-do-i-load-binary-image-data-using-javascript-and-xmlhttprequest
    function imageFieldChanged(event){


        var imageField = $(this),
            files = this.files,
            ugcForm = imageField.closest('form'),
            thumbnail = ugcForm.find('.thumb'),
            reader,

            removeButton = $($.el.button({'type':'button','class':'remove btn'}, $.el.i({'class':'icon-remove'}) ));

        imageField.closest('.imageAttachments').find('.thumbContainer').append(removeButton);

        removeButton.on('click', function(){
            var imageAttachments = $(this).closest('.imageAttachments');
            imageAttachments.find('.group-for-image').replaceWith(createImageUploadField());

            //There seems to be a bug where you can't un-give and image to an img tag..
            imageAttachments.find('.thumb').removeAttr('src').replaceWith(imageAttachments.find('.thumb').clone().text(''));

            $(this).remove();
        });

        if(!hasFileReader){
            var fileName = imageField.val().split('\\').pop().split('/').pop(); // split back and forward slashes for windows and everything else.
            thumbnail.text(fileName);
            return;
        }

        reader = new window.FileReader();

        reader.onload = function(event){
            thumbnail.attr('src', event.target.result);
        };

        reader.readAsDataURL(files[0]);
    }




    /////////////////////
    // Initialise Ugc Form
    /////////////////////

    function initialiseUgcForm(element){
        var ugcFormWrapper = $(element),
            settings = ugcFormWrapper.data('ugc'),
            form;

        rnn.modules.user.get(function(user){


            if(!user.authenticated){
                var loginMessage = 'login to share your story';

                if(settings.subtype.toLowerCase() === 'image'){
                    loginMessage = 'login to share your image';
                }

                form = rnn.modules.login.createForm(loginMessage);
            }else{
                form = createUGCForm(settings);
            }

            ugcFormWrapper.append(form);

        });
    }

    function createUgcWrapper(settings){
        var formWrapper = $.el.div({'class':'ugcWrapper'});
        $(formWrapper).data('ugc',settings);
        initialiseUgcForm(formWrapper);
        return formWrapper;
    }

    // Initialise Bootstrap plugins
    function initUgc() {

        maps = rnn.modules.maps;
        loading = rnn.modules.loading;

        $('.ugcWrapper').each(function(){
            initialiseUgcForm(this);
        });

        $(document)
            .on('submit', '.ugc', submitUgcForm)
            .on('change', 'input[type="file"]', imageFieldChanged);


        $(rnn).on('login',function(){
            var $ugcWrappers = $('.ugcWrapper');

            $ugcWrappers.each(function(){
                $ugcWrapper = $(this);
                $ugcWrapper.find('form.login').remove();
                initialiseUgcForm(this);
            });
        });
    }

    rnn.modules.register("ugc", {
        init: initUgc,
        create: createUgcWrapper
    });

})(jQuery);
